module.exports = __webpack_public_path__ + "static/media/reactjs-og.3bed97fb.svg";